import { useRef, useState } from "react";
import { parseTL } from "../AmountInput";
import { todayIso } from "../../lib/format";
import { emptyLine } from "./cardUtils";

// Ekstre satırları: ekle/sil/değiştir + Enter/Tab ile satır gezinme
export function useStatementLines(cardBudget) {
  const [lines, setLines] = useState([emptyLine()]);
  const linesRef = useRef(null);
  const changeLine = (i, patch) => setLines((ls) => ls.map((l, j) => (j === i ? { ...l, ...patch } : l)));
  const addLine = () => setLines((ls) => {
    const last = ls[ls.length - 1];
    const inherited = cardBudget || { budget_parent_id: last?.budget_parent_id || "", budget_item_id: last?.budget_item_id || "" };
    return [...ls, { ...emptyLine(), ...inherited, tx_date: last?.tx_date || todayIso() }];
  });
  const removeLine = (i) => setLines((ls) => (ls.length > 1 ? ls.filter((_, j) => j !== i) : ls));
  const focusLine = (i, field) => {
    let tries = 0;
    const attempt = () => {
      const wrap = linesRef.current?.querySelector(`[data-line="${i}"] [data-field="${field}"]`);
      const el = wrap?.querySelector("input, select, button, [tabindex]") || wrap;
      if (el) el.focus();
      if ((!el || document.activeElement !== el) && ++tries < 8) setTimeout(attempt, 60);
    };
    requestAnimationFrame(() => requestAnimationFrame(attempt));
  };
  const onLineKey = (e, i) => {
    if (e.key !== "Enter" && e.key !== "Tab") return;
    if (e.target.closest("[data-searchable]") && e.key === "Enter") return;
    const isLast = e.target.closest("[data-field=description]");
    if (isLast && !e.shiftKey) {
      e.preventDefault();
      if (i === lines.length - 1) addLine();
      focusLine(i + 1, "tx_date");
    } else if (e.key === "Enter") {
      e.preventDefault();
      const els = [...linesRef.current.querySelectorAll("input:not([disabled]), select:not([disabled])")];
      const nx = els[els.indexOf(e.target) + 1];
      if (nx) nx.focus();
      else if (i === lines.length - 1) { addLine(); focusLine(i + 1, "tx_date"); }
    }
  };
  const linesTotal = lines.reduce((s, l) => s + (parseTL(l.amount) || 0), 0);
  const resetLines = () => setLines([emptyLine()]);
  return { lines, setLines, linesRef, changeLine, addLine, removeLine, focusLine, onLineKey, linesTotal, resetLines };
}
